// admin-backend's user PII deletion overwrites the account's name, email and authored folder comments with this sentinel
export const PII_DELETED_SENTINEL = '*DELETED*'
export const DELETED_USER_NAME = 'Deleted user'

/**
 * Get the first initial of a user's name, defaulting to 'UN' if no valid name is provided
 * @param {string} name - The user's name
 * @returns {string} - The first initial in uppercase, or 'UN' if no valid name
 */
export function getUserFirstInitial(name) {
  if (!name || !name.trim()) return 'UN'
  return name[0].toUpperCase()
}
